
<template>
    <div  class="filter">
        <transition name="slide-fade" :duration="{ enter: 500, leave: 0 }">
            <div class="filterContainer">
                <h3>Filter by Product Category:</h3><br>
                <label > 
                     All
                    <input type="radio" value="All" v-model="selectedCat">
                </label>
                <div v-for="c in cat">
                    <label>
                        {{c}}
                        <input type="radio" :value="c" v-model="selectedCat" >
                    </label>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "FilterProduct",
        props: {
           cat:[],
           saveCat:""
        },
        data(){
            return{
                selectedCat: this.saveCat
            }
        },
        watch: {
            selectedCat(){
                this.$emit("setSelectedCat", this.selectedCat)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .filter {
        position: absolute;
        z-index: 99;
        background: #f9f9f9;
        width: auto;
        text-align: left;
        min-width: 255px;
        max-width: 350px;
        padding: 13px;
        transition: height 0.5s linear;
        border: 1px solid #004570;
        border-radius: 5px;
        box-shadow: 0 0 8px #d2d2d2;
        .filterContainer{
            display: flex;
            flex-direction: column;
            align-content: center;
            width: auto;
            justify-content: space-around;
            label{
                display : block;
                line-height:1.4em;
                
                input{
                    float:right;
                }
            }
        }
        .slide-fade-enter-active {
             transition: all .3s ease;
         }
        .slide-fade-leave-active {
            transition: all 0s ease;
        }
        .slide-fade-enter,
        .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
        {
            transform: translateY(10px);
            opacity: 0;
        }
        @media screen and (min-width: 550px){
           // position:relative;
            float:left;
        }
             
    }
   
</style>